// extracted by mini-css-extract-plugin
module.exports = {"docPositionContainer0_560":"docPositionContainer0_560___1vkif","docPositionContainer0560":"docPositionContainer0_560___1vkif"};